<script setup lang="ts">
import type { NavItem } from '~/types/ui/uiTypes'

const props = withDefaults(defineProps<{
  items: NavItem[]
  modelValue: boolean
  activePath: string
}>(), {
})

const emit = defineEmits<{
  'update:modelValue': [value: boolean]
}>()

function close() {
  emit('update:modelValue', false)
}

watch(() => props.activePath, () => {
  close()
})

const resolvedActiveClass = 'text-accent-2'
const overlayClass = 'bg-black/30'
const listDividerClass = 'divide-rule-soft'
const itemHoverClass = 'hover:bg-rule-soft'
const itemInactiveClass = 'text-ink'
</script>

<template>
  <Transition
    enter-active-class="transition-opacity duration-150 ease-out"
    enter-from-class="opacity-0"
    enter-to-class="opacity-100"
    leave-active-class="transition-opacity duration-150 ease-in"
    leave-from-class="opacity-100"
    leave-to-class="opacity-0"
  >
    <div v-if="props.modelValue" class="fixed inset-0 z-50">
      <div class="touch-action-manipulation absolute inset-0 cursor-pointer" :class="overlayClass" @click="close" />
      <div class="absolute inset-x-0 bottom-0 px-3 pb-[calc(3.75rem+env(safe-area-inset-bottom))]">
        <UICard
          radius="2xl"
          padding="none"
          class="mx-auto w-full max-w-6xl overflow-hidden"
        >
          <div class="flex items-center justify-between px-4 py-3">
            <UIText variant="label" tone="neutral">
              More
            </UIText>
            <UIButton
              variant="icon"
              size="sm"
              aria-label="Close"
              class="-mr-1.5"
              @click="close"
            >
              <UIIcon name="close" size="lg" />
            </UIButton>
          </div>
          <div class="divide-y" :class="listDividerClass">
            <NuxtLink
              v-for="item in props.items"
              :key="item.path"
              :to="item.path"
              :prefetch="props.activePath !== '/'"
              class="flex items-center gap-3 px-4 py-3 text-sm transition-colors"
              :class="isActivePath(activePath, item.path) ? resolvedActiveClass : `${itemInactiveClass} ${itemHoverClass}`"
              @click="close"
            >
              <UIIcon :name="item.icon" size="md" />
              <UIText as="span" weight="medium">
                {{ item.label }}
              </UIText>
            </NuxtLink>
            <UIText v-if="props.items.length === 0" variant="small" class="px-4 py-3">
              No items available.
            </UIText>
          </div>
        </UICard>
      </div>
    </div>
  </Transition>
</template>
